import { render, staticRenderFns } from "./LegacyPortfolioSelect.vue?vue&type=template&id=37e9534b&scoped=true&"
import script from "./LegacyPortfolioSelect.vue?vue&type=script&lang=js&"
export * from "./LegacyPortfolioSelect.vue?vue&type=script&lang=js&"
import style0 from "./LegacyPortfolioSelect.vue?vue&type=style&index=0&id=37e9534b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9534b",
  null
  
)

export default component.exports